import Service 			from "./../../Libs/Service";

let Storyboard = new Service({

	Name: "Storyboard",

	Libraries: [],

	Events: {

	},

	Actions: {

	},

	init() {

	}

});

window.Storyboard = Storyboard;

export { Storyboard }
